import { defineMessages } from 'react-intl-next';

export const messages: {
	errorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	learnMore: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	zeroByteErrorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	zeroByteErrorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	errorTitle: {
		id: 'company-hub-common.attachment-size-limit-error.title',
		defaultMessage: '{fileName} is too large to upload',
		description:
			"Message describing that the chosen file could not be uploaded due to the file's size",
	},
	errorDescription: {
		id: 'company-hub-common.attachment-size-limit-error.description',
		defaultMessage: 'Attachments must be {size} or less.',
		description: 'Message describing what the maximum size limit for attachments is set to',
	},
	learnMore: {
		id: 'company-hub-common.attachment-size-limit-error.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link for users who want to understand why they are receiving this error message',
	},
	zeroByteErrorTitle: {
		id: 'company-hub-common.attachment-zero-byte-error.title',
		defaultMessage: '{fileName} is empty (zero bytes)',
		description: 'Message describing that the chosen file has no contents, i.e. has zero bytes',
	},
	zeroByteErrorDescription: {
		id: 'company-hub-common.attachment-zero-byte.description',
		defaultMessage: 'Attachments must be at least 1 byte of size',
		description: 'Message describing what the minimum size is',
	},
});
